import { render, staticRenderFns } from "./admin-inmuebles-detalle.vue?vue&type=template&id=24748a1c&"
import script from "./admin-inmuebles-detalle.vue?vue&type=script&lang=js&"
export * from "./admin-inmuebles-detalle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports